<template>

  <div class="col">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-toolbar
          flat
          v-if="containTopToolbar">
          <v-text-field
            v-if="containSearchBar"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
            autofocus
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn
            v-if="false"
            @click="openAllCharts = !openAllCharts"
          >
            {{openAllCharts ? "Fechar" : "Expandir"}} Todos os Planos de Conta
          </v-btn>

          <New
            v-if="$can('create', $router.currentRoute.name) && !readOnly"
            @entry-created="entryCreated"
            :modelNameSingular="modelNameSingular"
          />

        </v-toolbar>
      </v-col>
    </v-row>
  <v-row>
    <v-col cols="12">
      <v-treeview
        v-if="!loading"
        :search="search"
        hoverable
        activatable
        :open-on-click="unableToSelectParentNodes"
        :open-all="openAllCharts"
        :items="chartOfAccounts"
        :key="openAllCharts"
        :active.sync="activeChartOfAccounts"
        return-object
        item-key="id"
        item-text="text"
        item-children="children"
      >
        <template v-slot:append="{ item }">
          <Edit
            v-if="$can('update', $router.currentRoute.name) && !readOnly"
            :entry="item"
            @entry-updated="entryUpdated"
            :modelNameSingular="modelNameSingular"
          />
          <Delete
            v-if="$can('delete', $router.currentRoute.name) && !readOnly"
            :entry="item"
            @entry-destroyed="entryDeleted"
            :modelNameSingular="modelNameSingular"
          />
        </template>
      </v-treeview>
    </v-col>
  </v-row>

    <v-snackbar 
      v-model="snackbarSuccess" 
      :timeout="timeout" 
      color="success"
      shaped
    >
      {{ confirmationMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn 
          icon 
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar 
      v-model="snackbarError" 
      :timeout="timeout" 
      color="error"
      shaped
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn 
          icon 
          v-bind="attrs"
          @click="snackbarError = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>

</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "../../shared/base_index.vue";
// import New from "./new.vue";
// import Edit from "./edit.vue";
import Delete from "./delete.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      chartOfAccounts: [],
      loading: true,
      openAllCharts: true,
      containSearchBar: true,
      containTopToolbar: true,
      search: "",
      activeChartOfAccounts: [],
      snackbarSuccess: false,
      snackbarError: false,
      confirmationMessage: "",
      errorMessage: "",
      timeout: 10000,
      pageLoading: false,
    };
  },
  props: {
    subtreesOfCodes: {
      type: Array,
      default: () => null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    loadActiveChartOfAccount: {
      type: Object,
      default: null
    },
    unableToSelectParentNodes: {
      type: Boolean,
      default: true
    },
    modelNameSingular: {
      type: String,
      default: "Plano de Contas"
    },
    modelNamePlural: {
      type: String,
      default: "Planos de Contas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    // New: New,
    // New: () => import('./new.vue'),
    // Edit: Edit,
    // Edit: () => import('./edit.vue'),
    Delete: Delete,
    BaseUtil: BaseUtil,
  },
  beforeCreate: function () {
    this.$options.components.New = require('./new.vue').default
    this.$options.components.Edit = require('./edit.vue').default 
  },
  created() {
    this.loadServerEntries();

    // console.log("CREATE this.loadActiveChartOfAccount", this.loadActiveChartOfAccount)
      if (this.loadActiveChartOfAccount) {
        this.activeChartOfAccounts.push(this.loadActiveChartOfAccount);
      }
  },
  methods: {
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_CHART_OF_ACCOUNTS,
          variables: {
            subtreesOfCodes: this.subtreesOfCodes
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.chartOfAccounts = response.data.globalContext.allChartOfAccounts;
          // console.log("All chartOfAccounts", this.chartOfAccounts);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.util.showConfirmationMessage("Plano de contas atualizado com sucesso!");
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.util.showConfirmationMessage("Plano de contas criado com sucesso!");
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.util.showConfirmationMessage("Plano de contas removido com sucesso!");
    },
    showConfirmationMessage: function(message) {
      this.snackbarSuccess = true;
      this.confirmationMessage = message;
    },
    showErrorMessage: function(message) {
      this.snackbarError = true;
      this.errorMessage = message;
    },
  },
  watch: {
    loading: function() {
      this.$emit("index-loading", this.loading);
    },
    activeChartOfAccounts: function() {
      this.$emit("chart-selected", this.activeChartOfAccounts);
    },
    // loadActiveChartOfAccount: function() {
    //   console.log("WATCH this.loadActiveChartOfAccount", this.loadActiveChartOfAccount)
    //   if (this.loadActiveChartOfAccount) {
    //     this.activeChartOfAccounts.push(this.loadActiveChartOfAccount);
    //   }
    // }
  }
};

const LOAD_ALL_CHART_OF_ACCOUNTS = gql `
  query ($subtreesOfCodes: [String!]) {
    globalContext {
      allChartOfAccounts(subtreesOfCodes: $subtreesOfCodes) {
        id
        code
        text
        children {
          id
        	code
        	text
          children {
            id
            code
            text
            children {
              id
              code
              text
              children {
                id
                code
                text
                children {
                  id
                  code
                  text
                  children {
                    id
                    code
                    text
                    children {
                      id
                      code
                      text
                      children {
                        id
                        code
                        text
                        children {
                          id
                          code
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .v-treeview-node__label {
    flex: none;
  }
</style>
